import NotFound from "pages/notFound";
import { ADMIN as BASE } from ".";

export const ADMIN_NOT_FOUND = BASE.child("/*", NotFound);
